/*
 * @Author: wuqinfa
 * @Date: 2022-05-25 10:06:23
 * @LastEditTime: 2022-08-14 15:35:40
 * @LastEditors: wuqinfa
 * @Description: 定义权限值
 */

export default {
    /*
     * 控制角色可见度的功能
     *  隐藏状态： 如果没有这个权限的话，底部角色渲染栏不会出现隐藏的角色，并且积木编辑区域也不会出现其角色对应的积木
     */
    spriteVisibility: 'spriteVisibility',
}